export enum actionTypes {
  MENSAJES_FETCH = 'MENSAJES_FETCH',
  MENSAJES_SUCCESS = 'MENSAJES_SUCCESS',
  MENSAJES_ERROR = 'MENSAJES_ERROR',
  MENSAJES_RESET = 'MENSAJES_RESET',
}

export enum MensajesStatus {
  Idle,
  Loading,
  Error,
  Success,
  Filtering,
}

export enum EstadoMensaje {
  leido = 'leido',
  no_leido = 'no_leido',
  todos = 'todos',
}
export enum TipoMensaje {
  TODOS = 'todos',
  RECIBIDOS = 'recibidos',
  ENVIADOS = 'enviados',
}
export enum OrigenMensaje {
  CURRICULUM = 'curriculum',
  POSTULACION = 'postulacion',
  TODOS = 'todos',
}

export interface FiltrosMensajes {
  estado?: EstadoMensaje
  tipo?: TipoMensaje
  origen?: OrigenMensaje
  avisoId?: number
  page?: number
  pageSize?: number
}

export interface Link {
  href: string
  rel: string
  templated: boolean
}

export interface Mensaje {
  apellido: string
  nombre: string
  fechaModificacion: string
  id: number
  leido: boolean
  links: Link[]
  logoURL: string
  postulanteId: number
  tipo: OrigenMensaje
  titulo: string
}

export interface MensajeState {
  status: MensajesStatus
  content: Mensaje[]
  number: number
  size: number
  total: number
  filters: FiltrosMensajes
}

export interface MensajesFetch {
  type: typeof actionTypes.MENSAJES_FETCH
  payload: { filters: FiltrosMensajes; isInitial: boolean }
}

export interface MensajesSuccess {
  type: typeof actionTypes.MENSAJES_SUCCESS
  payload: { content: Mensaje[]; number: number; size: number; total: number }
}

export interface MensajesError {
  type: typeof actionTypes.MENSAJES_ERROR
  payload: null
}

export interface MensajesReset {
  type: typeof actionTypes.MENSAJES_RESET
  payload: null
}
export type MensajesActions = MensajesFetch | MensajesSuccess | MensajesError | MensajesReset

export const initialState: MensajeState = {
  status: MensajesStatus.Idle,
  content: [],
  number: 0,
  size: 10,
  total: 0,
  filters: { page: 0, pageSize: 10 },
}
